import React from 'react'
import { ErrorMessage } from 'utils-next/forms'

import { Typography } from '@mui/material'

export class MaterialFormikErrorMessage extends React.PureComponent<MaterialFormikErrorMessageProps> {
  render() {
    const { name, className } = this.props
    return (
      <Typography className={className} color={'error'}>
        <ErrorMessage name={name}></ErrorMessage>
      </Typography>
    )
  }
}

export type MaterialFormikErrorMessageProps = {
  className?: string
  name: string
}
